<template lang="pug">
div
    template(v-if="$storyblok.isEditing")
        p(class="font-bold mb-1") Test: {{ data.testId }}
        div(class="border-b mb-2 space-x-2 uppercase font-bold")
            template(v-for="(tab, index) in groupTabs")
                div(
                    v-bind="tab.bridgeData"
                    @click="editingGroupIndex = index"
                    class="relative inline-block py-2 px-4 border border-b-0 rounded-t cursor-pointer"
                    :class="tab.class"
                )
                    | {{ tab.name }}
                    span(
                        v-if="tab.hasError"
                        class="absolute flex h-4 w-4 right-0 top-0 -mr-2 -mt-2"
                    )
                        span(class="animate-ping absolute inline-flex h-full w-full rounded-full bg-danger opacity-75")
                        span(class="relative inline-flex rounded-full h-4 w-4 bg-danger")

    template(v-if="activeTestGroup")
        template(v-for="widget in activeTestGroup.widgets")
            slot(:data="widget")

</template>

<script>
import { bindStoryblokBridgeData } from '../../helpers'

export default {
    name: 'ABTestWidget',
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            editingGroupIndex: 0,
        }
    },
    computed: {
        groupTabs() {
            if (!this.$storyblok.isEditing) return []

            return this.data.testGroups.map((testGroup, index) => {
                const { variantId } = testGroup

                const isSelected = this.editingGroupIndex === index
                const hasError =
                    this.data.testGroups.filter((groups) => groups.variantId === variantId).length >
                    1

                return {
                    name: variantId.trim() || 'Original',
                    bridgeData: bindStoryblokBridgeData(testGroup),
                    class: {
                        'text-white bg-info': isSelected && !hasError,
                        'bg-white': !isSelected && !hasError,
                    },
                    hasError,
                }
            })
        },
        activeTestGroup() {
            return (
                this.data.testGroups.find((testGroup, index) => {
                    if (this.$storyblok.isEditing) {
                        return this.editingGroupIndex === index
                    }

                    return this.$abTest.isVariantActive(this.data.testId, testGroup.variantId)
                }) || this.data.testGroups.find(({ variantId }) => variantId === '')
            )
        },
    },
    watch: {
        // NOTE: This watcher only fires when in editmode because thats when the content is changing
        groupTabs(newVal) {
            if (this.editingGroupIndex >= newVal.length) this.editingGroupIndex = 0
        },
    },
}
</script>
